/**
 * Enums containing the different modes the Client-component has.
 */
export enum Mode {
  API = 'API',
  DIRECT_HANDLE = 'DIRECT_HANDLE',
}
